module.exports = __webpack_public_path__ + "static/media/Slots.68f21849.svg";